import { CartDiscounts, CartType } from '@monorepo/types';
import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import {
  fetchCart,
  fetchCartDiscounts,
} from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { useQuery } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.CART;

export const useCart = () => {
  return useQuery<CartType>({
    queryKey: QUERY_KEYS[CONFIG_KEY].DETAILS,
    queryFn: fetchCart,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
  });
};

export const useCartDiscounts = () => {
  return useQuery<CartDiscounts>({
    queryKey: QUERY_KEYS[CONFIG_KEY].DISCOUNTS,
    queryFn: fetchCartDiscounts,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
  });
};
